module.exports = __webpack_public_path__ + "img/behold-12.b86db609.png";